export interface Positioned {
	id: string
	order: number
}

// Pick an order value between the drop point's neighbours instead of renumbering
// the container. A drop into an existing gap writes one row; only when the gap is
// exhausted does the cascade rewrite rows, and it stops at the first row that
// already has room.
export function planInsert(
	siblingsInOrder: readonly Positioned[],
	insertIndex: number,
): { order: number; siblings: Positioned[] } {
	const before = siblingsInOrder[insertIndex - 1]
	const after = siblingsInOrder[insertIndex]

	if (!before) return { order: after ? after.order - 1 : 0, siblings: [] }
	if (!after) return { order: before.order + 1, siblings: [] }

	const gap = after.order - before.order
	if (gap >= 2) {
		return { order: before.order + Math.floor(gap / 2), siblings: [] }
	}

	let cursor = before.order + 1
	const siblings: Positioned[] = []
	for (let i = insertIndex; i < siblingsInOrder.length; i++) {
		const row = siblingsInOrder[i]
		if (!row || row.order > cursor) break
		cursor += 1
		siblings.push({ id: row.id, order: cursor })
	}
	return { order: before.order + 1, siblings }
}
